import type { MapItem } from './Map/ListingMap';
// import { type IconString } from '2-core-elements/Icon/Icon';
import { type IconString } from '2-core-elements/Icon/DuotoneIcon';


export type AssetsIcon = IconString;

export interface GoogleMapPinProps {
    // eslint-disable-next-line react/no-unused-prop-types
    lat?: number;
    // eslint-disable-next-line react/no-unused-prop-types
    lng?: number;
    style?: React.CSSProperties;
}


export const filterItemsById = (
    items: MapItem[],
    activeItemId: string
): MapItem[] => {
    return items.filter(({ id }) => {
        return id === activeItemId;
    });
};

export const assetIcon = {
    // Airports: 'airport-01',
    // GasElectric: 'electricity',
    // GasProcessing: 'gas-01',
    // RenewableNaturalGas: 'gas-01',
    // Government: 'government',
    // HeatingCooling: 'pipeline-02',
    // Renewables: 'wind-power-01',
    // Seaports: 'seaport-04',
    // Road: 'road-01',
    // WaterWastewater: 'water-01',
    // Pipelines: 'pipeline-01',
    // EnergyStorage: 'solar-power-02',
    // Diversified: 'diversity',
    // DataStorage: 'data-01',
    // Education: 'education',
    // AgedCare: 'healthcare',
    // PublicTransport: 'rail',
    // Telecommunications: 'digital',
    Map: `map`,
    Office: `map`,
    Operation: `operation`,
};


// based on figma: https://www.figma.com/file/8yYdqJ3M4sx6j5pBWSMl2A/IFM-Design-System?type=design&node-id=25500-176908&t=IsIKj1ThA6oWQDge-0
// it seems like it's sector dependant for now.
export const getIconByCategory = (assetType: string): AssetsIcon => {
    // default if not found
    if (!assetIcon[assetType]) {
        return 'map';
    }

    return assetIcon[assetType];
};
